import { render } from "./InstructionEdit.vue?vue&type=template&id=617c3cf1&scoped=true"
import script from "./InstructionEdit.vue?vue&type=script&lang=js"
export * from "./InstructionEdit.vue?vue&type=script&lang=js"

import "./InstructionEdit.vue?vue&type=style&index=0&id=617c3cf1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617c3cf1"]])

export default __exports__